(function () {
'use strict';

angular
    .module('actionPlanCriteriaEditRoutes', [
        'actionPlanCriteriaEditModule',
    ])
    .config(router);

    router.$inject = ['$stateProvider', '$urlRouterProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, $urlRouterProvider, historyCtxtServiceProvider) {
        $stateProvider

            // Action Plan Criteria - Add
            .state('recommendation.edit.actionPlan.edit.actionPlanCriteriaAdd', {
                url: '/ActionPlanCriteria/Add',
                resolve: {
                    actionPlanCriteria: ['$stateParams', function ($stateParams) {
                        return { ActionPlanID: $stateParams.ActionPlanID };
                    }]
                    
                },
                views: {
                    'mainContent@recommendation': {
                        templateUrl: require('./actionPlanCriteriaEdit.tpl.html'),
                        controller: 'ActionPlanCriteriaEditController'
                    }
                }
            })

            // Action Plan Criteria - Edit
            .state('recommendation.edit.actionPlan.edit.actionPlanCriteriaEdit', {
                url: '/ActionPlanCriteria/{ActionPlanCriteriaID:int}',
                resolve: {
                    actionPlanCriteria: ['$stateParams', 'grcActionPlanCriteriaService', function ($stateParams, service) {
                        return service.getActionPlanCriteria($stateParams.ActionPlanCriteriaID);
                    }],
                    modal: function () { return {} }
                },
                onEnter: ['$rootScope', '$modal', '$state', 'actionPlan', 'actionPlanCriteria', 'modal',
                    function ($rootScope, $modal, $state, actionPlan, actionPlanCriteria, modal) {
                        // Modal to show
                        var modalScope = $rootScope.$new(true);
                        modalScope.actionPlan = actionPlan;
                        modalScope.actionPlanCriteria = actionPlanCriteria;

                        modalScope.close = function (withReload) {
                            $state.go('^', null, {reload: !!withReload, location: 'replace'});
                        };

                        modalScope.$on('modal.hide', function () {
                            modalScope.$destroy();

                            if (_.isNil(modal.instance)) return;

                            if ($state.is('recommendation.edit.actionPlan.edit.actionPlanCriteriaEdit')) {
                                $state.go('^');
                            }
                        });

                        modal.instance = $modal({
                            scope: modalScope,
                            template: '/app/shared/grc/actionPlanCriteria/grcActionPlanCriteriaEdit.modal.tpl.html',
                            placement: 'center'
                        });
                    }],
                onExit: ['modal', function (modal) {
                    if (!_.isNil(modal.instance)) {
                        modal.instance.$promise.then(function () {
                            modal.instance.hide();
                            modal.instance = null;
                        });
                    }
                }],
            });
    }
})();